// extracted by mini-css-extract-plugin
export default {"root":"kwYj7","button":"jplnA","buttonTooltip":"_Y_i0"};